<h1 style="color:#e7bd42">I nostri servizi</h1>
<div class="layout horizontal center middle">
        <app-tile-set 
                [settings] = settings
                [tiles] = tiles>
        </app-tile-set>
</div>
